import { useContext } from "react";
import { Outlet } from "react-router-dom";
import UserContext from "../../context/user/UserContext";
import Error403Page from "../../pages/error/403";
// import { MeService } from "../../services/auth";

const ManagersMiddleware = () => {

    const { roles} = useContext(UserContext);

    if(roles.includes(2))
    {
        return <Outlet />
    }else
    {
        return <Error403Page />
    }

}

export default ManagersMiddleware;